import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  anotherSidebarShow: false,
  sidebarMinimize: false,
  theme_mode: 'light'
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  toggleAnotherSidebar (state) {
    const sidebarOpened = [false, 'responsive'].includes(state.anotherSidebarShow)

    state.anotherSidebarShow = sidebarOpened ? true : false
  },
  toggle_theme_mode (state) {
    const my_theme = state.theme_mode;
if(my_theme == 'light'){
  state.theme_mode = 'dark';
}else{
  state.theme_mode = 'light';

}
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations
})